"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var user_config_1 = __importDefault(require("./user.config"));
var UserService = /** @class */ (function (_super) {
    __extends(UserService, _super);
    function UserService(BASE_URL, FUNCTIONS_KEY) {
        var _this = _super.call(this, BASE_URL, FUNCTIONS_KEY) || this;
        /**
         * API name: validateUserEmail
         */
        _this.validateUserEmail = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/validate-user-email?EmailId=".concat(data.emailId, "&Token=").concat(data.token))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /**
         * API name: validatePhoneUser
         */
        _this.validatePhoneUser = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/validate-phone-user?PhoneId=".concat(data.id, "&Token=").concat(data.token))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /**
         * API name: validatTokenUser
         */
        _this.validateTokenUser = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/validate-token-user?Id=".concat(data.id, "&Token=").concat(data.token))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /*
         * API name: address
         */
        _this.updateAddress = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.put("/api/v2/usuario/".concat(data.usuarioId, "/direccion/").concat(data.id), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.createAddress = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v2/usuario/".concat(data.usuarioId, "/direccion"), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /*
         * API name: phone
         */
        _this.createPhonecontact = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v2/usuario/".concat(data.usuarioId, "telefono"), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getPhonecontact = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/usuario/".concat(data.usuarioId, "/telefonos"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getHiddenPhonecontact = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-hidden-phonecontact?Id=".concat(data.usuarioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.updatePhonecontact = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.put("/api/v2/usuario/".concat(data.usuarioId, "/telefono/").concat(data.id), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.deletePhoneContact = function (userId, id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.delete("/v2/usuario/".concat(userId, "/telefono/").concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /*
         * API name: user
         */
        // getMainUser = async(data:IUser): Promise<any> => {
        //   return await this.axios.get(`/api/v1/get-main-user?Id=${data.id}`)
        // }
        _this.createUserFull = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v2/usuario/completo")];
                    case 1: return [2 /*return*/, (_a.sent(), data)];
                }
            });
        }); };
        _this.createUser = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v2/usuario/")];
                    case 1: return [2 /*return*/, (_a.sent(), data)];
                }
            });
        }); };
        _this.getUser = function (UsuarioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/usuario/".concat(UsuarioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        // otp telefono e email
        _this.getOtpPhoneEmail = function (usuarioId, telefono, email) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.put("/api/v2/crear-otp/".concat(usuarioId, "?telefono=").concat(telefono, "&email=").concat(email))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.updateUser = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.put("/api/v2/usuario/".concat(data.id), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.deleteUser = function (usuarioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.delete("/api/v2/usuario/".concat(usuarioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getUserStatus = function (usuarioId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-users-status?UserId=".concat(usuarioId))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getFreelanceByCollaborator = function (UserFilterFreelanceId) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v1/get-freelance-by-collaborator", {
                            params: UserFilterFreelanceId,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        /*
         * API name: email
         */
        _this.createEmail = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.post("/api/v2/usuario/".concat(data.usuarioId, "/email"), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getEmail = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/usuario/".concat(data.usuarioId, "/email/").concat(data.id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getEmails = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.get("/api/v2/usuario/".concat(data.usuarioId, "/emails/"))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.upDateEmail = function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.put("/api/v2/usuario/".concat(data.usuarioId, "/email/").concat(data.id), data)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.deleteEmail = function (usuarioId, id) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.axios.delete("/api/v2/usuario/".concat(usuarioId, "/email/").concat(id))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        return _this;
    }
    return UserService;
}(user_config_1.default));
exports.default = UserService;
